import axiosSetup from "../utils/axiosSetup";

export const fetchMusterApi = async (month: number, year: number) => {
  try {
    const res = await axiosSetup.get(
      `/muster/all-active-user?month=${month}&year=${year}`
    );
    return res.data.data; 
  } catch (error) {
    throw error;
  }
};

export const lockUnlockUserApi = async (userId: string, lock: boolean) => {
  try {
    const res = await axiosSetup.post("/employee-details/lock-user", { userId, lock });
    return res.data;
  } catch (error: any) {
    throw error;
  }
};